const twoColumnGrid = document.querySelector('.two-column-grid')
const fourColumnGrid = document.querySelector('.four-column-grid')

twoColumnGrid.addEventListener('click', () => {
  const productGrid = document.querySelector('.dynamic-grid')
  productGrid.classList.add('two-column')
})

fourColumnGrid.addEventListener('click', () => {
  const productGrid = document.querySelector('.dynamic-grid')
  productGrid.classList.remove('two-column')
})